<template>
	<v-dialog v-model="dialog" persistent max-width="500" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-13 secondary--text">Input RO Manual</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text v-if="dialog">
				<v-col class="px-0 cl-secondary font-size-11">
					<v-row>
						<v-col cols="12">
							<div class="font-size-11 cl-dark-green mb-2">Tambah Input Serial</div>
							<template>
								<v-btn small depressed color="teal lighten-2 white--text" class="ml-1 rounded-pill" @click="addInput(1)">
									<v-icon small>mdi-plus</v-icon>
									<span class="pl-1 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">1</span>
								</v-btn>
								<v-btn small depressed color="teal lighten-2 white--text" class="ml-1 rounded-pill" @click="addInput(5)">
									<v-icon small>mdi-plus</v-icon>
									<span class="pl-1 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">5</span>
								</v-btn>
								<v-btn small depressed color="teal lighten-2 white--text" class="ml-1 rounded-pill" @click="addInput(10)">
									<v-icon small>mdi-plus</v-icon>
									<span class="pl-1 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">10</span>
								</v-btn>
							</template>
						</v-col>
            <v-col cols="12">
              <v-form ref="formSerial">
								<div class="d-flex flex-wrap" v-for="(input, i) in serialData" :key="i">
									<v-col cols="5" class="pt-0 pl-0">
										<v-text-field hide-details="auto" label="Kode Serial" :rules="rules.serial" v-model="input.serial"></v-text-field>
										<div class="pt-1 font-size-9 red--text text--lighten-2" v-if="input.serial_error">{{ input.serial_error }}</div>
									</v-col>
									<v-col cols="5" class="pt-0 pl-0">
										<v-text-field hide-details="auto" label="Pin Serial" :rules="rules.pin" v-model="input.pin"></v-text-field>
										<div class="pt-1 font-size-9 red--text text--lighten-2" v-if="input.serial_error_pin">{{ input.serial_error_pin }}</div>
									</v-col>
									<v-col cols="2" class="py-0 pl-0 text-center my-auto" v-if="serialData.length > 1">
										<v-btn x-small depressed fab color="red lighten-2 white--text" @click="delInput(input.id)">
											<v-icon small>mdi-delete</v-icon>
										</v-btn>
									</v-col>
								</div>
							</v-form>
            </v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="py-4 justify-center">
				<v-col cols="4" class="py-0">
					<v-btn depressed block color="primary" class="white--text rounded-xl text-capitalize" :loading="btnLoading" @click="showConfirmManual">
						<v-icon>mdi-arrow-right-bold-circle</v-icon>
						<span class="pl-2">Proses</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
      btnLoading: false,
      serialId: 1,
      serialData: [{
				id: 0,
				serial: '',
				pin: '',
				serial_error: '',
				serial_error_pin: '',
			}],
      serialParams: {
				serial: [],
			},
      rules: {
				serial: [v => !!v || 'Kode Serial tidak boleh kosong'],
				pin: [v => !!v || 'Pin Serial tidak boleh kosong'],
			},
		}
	},
	props: {
	},
	computed:{
		...mapState(['errorValidation']),
	},
	methods :{
    ...mapActions('repeatOrder', ['addRO']),

		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
    addInput(val) {
			for (let i = 0; i < val; i++) {
				this.serialData.push({
					id: this.serialId,
					serial: '',
					pin: '',
					serial_error: '',
					serial_error_pin: '',
				})
				this.serialId++
			}
		},
    delInput(index) {
			this.serialData = this.serialData.filter(function(item) {
				return item.id !== index
			})
		},
    showConfirmManual() {
      if (this.$refs.formSerial.validate()) {
        this.$emit('action', 'show')
      }
    },
    processRO() {
      this.serialData.forEach((el) => {
				let data = {
					serial_id: '',
					serial_pin: '',
				}
				data.serial_id = el.serial
				data.serial_pin = el.pin
				this.serialParams.serial.push(data)
			})

      this.addRO(this.serialParams).then(() => {
				this.serialData = [{
          id: 0,
          serial: '',
          pin: '',
          serial_error: '',
          serial_error_pin: '',
        }]
				this.serialParams.serial = []
				this.modalHide()
				this.$emit('action', 'success')
			}).catch(() => {
        this.serialParams.serial = []
        this.$emit('action', 'error')
        this.serialData.map((el, index)=>{
          let err_index = this.errorValidation.results[index]
          el.serial_error = err_index.serial_error
          el.serial_error_pin = err_index.serial_error_pin
        })
			})
		}
	}
};
</script>